var createAssigner = require('./createAssigner');
var allKeys = require('./allKeys');

exports = createAssigner(allKeys);

module.exports = exports;
